export { default } from '@/components/Media/MediaImagePreview';
